import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { useNavigate } from 'react-router-dom';

const Commodities = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const navigate = useNavigate();
    useEffect(() => {
        if (currentLang !== 'fa') {
            navigate('/');;
        }
    }, [currentLang, navigate]);
    const content = {
        fa: {
            description: (
                <>
                    در این قسمت می‌توانید <strong className="fw-bold">محصولات قابل عرضه در بورس انرژی ایران</strong> را به همراه موارد زیر مشاهده‌کنید:
                </>
            ),
            list: [
                "معرفی و شرح محصول",
                "کاربرد محصول",
                "معرفی کالاهای هم‌گروه",
                "معرفی تولیدکنندگان پذیرفته‌شده محصول"
            ],
        },

        en: {
            description: (
                <>
                    Here you can view the <strong className="fw-bold">Products Offered on the Iran Energy Exchange</strong> along with the following items:
                </>
            ),
            list: [
                "Product Introduction and Description",
                "Product Applications",
                "Introduction of Similar Product Groups",
                "Introduction of Approved Product Manufacturers"
            ],
        },

        ar: {
            description: (
                <>
                    يمكنك هنا مشاهدة <strong className="fw-bold">المنتجات القابلة للعرض في بورصة الطاقة الإيرانية</strong> مع البنود التالية:
                </>
            ),
            list: [
                "التعريف بالمنتج ووصفه",
                "استخدامات المنتج",
                "التعريف بالمجموعات السلعية المشابهة",
                "التعريف بالمصنّعين المعتمدين للمنتج"
            ],
        },
    };

    const { description, list } = content[currentLang] || content.fa; // fallback to fa
    return (
        <div className="megaMenuContent commities-bg">
            <div className="row justify-content-between h-100">
                <div className="col-6">
                    <p className="text-nowrap">{description}</p>
                    <ul className="IeeStatuteList">
                        {list.map((item, idx) => (
                            <li key={idx}>{item}</li>
                        ))}
                    </ul>

                </div>
                <div className="col-12 d-flex align-items-end">
                    <a href="/Listing/Commodities" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                        {t("go_to_dashboard")}
                        <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                            {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                        </span>
                    </a>
                    
                </div>
            </div>

        </div>
    );
};

export default Commodities;
